module.exports = __webpack_public_path__ + "img/1-2.3a7cccc3.svg";